import { useCallback, useLayoutEffect, useRef, useState } from "react"

const ACTIONS_PANEL_WIDTH = 44 // ~2.7rem in pixels
const MARGIN = 8

export function useFlipActionsPanel() {
  const containerRef = useRef<HTMLDivElement>(null)
  const [shouldFlipToLeft, setShouldFlipToLeft] = useState(false)

  const checkAvailableSpace = useCallback(() => {
    if (!containerRef.current) return

    const containerRect = containerRef.current.getBoundingClientRect()
    const spaceOnRight = window.innerWidth - containerRect.right

    setShouldFlipToLeft(spaceOnRight < ACTIONS_PANEL_WIDTH + MARGIN)
  }, [])

  useLayoutEffect(() => {
    checkAvailableSpace()
    window.addEventListener("resize", checkAvailableSpace)
    return () => window.removeEventListener("resize", checkAvailableSpace)
  }, [checkAvailableSpace])

  return {
    containerRef,
    shouldFlipToLeft,
    checkAvailableSpace,
  }
}
